import { render, staticRenderFns } from "./SettingMoney.vue?vue&type=template&id=35319850&scoped=true&lang=pug&"
import script from "./SettingMoney.vue?vue&type=script&lang=js&"
export * from "./SettingMoney.vue?vue&type=script&lang=js&"
import style0 from "./SettingMoney.vue?vue&type=style&index=0&id=35319850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35319850",
  null
  
)

export default component.exports